const cards = [
  {
    title: '西瓜视频热播剧场',
    desc: '收录西瓜视频免费热门剧集，每日同步更新最新内容，高清画质不缓冲流畅播放，追剧首选平台。',
    icon: 'ri-movie-2-line',
    color: 'primary',
  },
  {
    title: '丝瓜视频精选合集',
    desc: '整理丝瓜视频优质影视资源，涵盖电视剧、综艺、纪录片等多种类型，一站式满足观看需求。',
    icon: 'ri-clapperboard-line',
    color: 'accent',
  },
  {
    title: '最新电视剧大全',
    desc: '每日追踪各大平台最新上线的电视剧，第一时间更新剧集列表，不错过任何一部热门新剧。',
    icon: 'ri-tv-2-line',
    color: 'secondary',
  },
  {
    title: '电影大全高清片库',
    desc: '汇聚国内外经典与最新电影资源，支持高清全集在线观看，分类清晰查找便捷，观影体验一流。',
    icon: 'ri-film-line',
    color: 'primary',
  },
  {
    title: '动漫番剧追更日历',
    desc: '热门国漫日漫同步更新，提供完整的追更时间表与剧集导航，二次元爱好者必收藏的追番利器。',
    icon: 'ri-ghost-line',
    color: 'accent',
  },
  {
    title: '综艺娱乐热门排行',
    desc: '实时更新热门综艺节目，从选秀到真人秀一应俱全，娱乐资讯与正片资源一站聚合呈现。',
    icon: 'ri-emotion-laugh-line',
    color: 'secondary',
  },
  {
    title: '纪录片知识频道',
    desc: '精选人文历史、自然科技、社会纪实等优质纪录片，在观影中开拓视野、增长见识与智慧。',
    icon: 'ri-global-line',
    color: 'primary',
  },
];

const colorMap: Record<string, { bg: string; text: string; iconBg: string }> = {
  primary: { bg: 'bg-primary-50', text: 'text-primary-700', iconBg: 'bg-primary-100' },
  accent: { bg: 'bg-accent-50', text: 'text-accent-700', iconBg: 'bg-accent-100' },
  secondary: { bg: 'bg-secondary-50', text: 'text-secondary-700', iconBg: 'bg-secondary-100' },
};

export default function CardsSection() {
  return (
    <section id="cards" className="py-16 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-3">
            内容频道
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-xl mx-auto">
            七大内容频道覆盖主流观影需求，总有一款适合你的口味
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4 md:gap-5">
          {cards.map((card, i) => {
            const c = colorMap[card.color];
            return (
              <div
                key={i}
                className="group bg-background-50 border border-background-200/70 rounded-2xl p-5 md:p-6 hover:border-background-300/80 transition-all duration-300 cursor-pointer"
              >
                <div className={`w-11 h-11 rounded-xl ${c.iconBg} flex items-center justify-center mb-4 group-hover:scale-110 transition-transform duration-300`}>
                  <i className={`${card.icon} text-xl ${c.text}`}></i>
                </div>
                <h3 className="text-base font-medium text-foreground-900 mb-2">{card.title}</h3>
                <p className="text-sm text-foreground-500 leading-relaxed">{card.desc}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}